export { default } from './LinkedInIcon';
